import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetEventLog(id: string | undefined) {
  return useQuery(queries.eventLogs.getEventById(id || ''))
}
